import { API_ENDPOINTS } from '../config';

/**
 * Create a new market
 */
export async function createMarket(question, resolutionDate = null) {
  const response = await fetch(API_ENDPOINTS.createMarket, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ question, resolution_date: resolutionDate }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to create market');
  }

  return response.json();
}

/**
 * Get market by ID
 */
export async function getMarket(marketId) {
  const response = await fetch(API_ENDPOINTS.getMarket(marketId));

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch market');
  }

  return response.json();
}

/**
 * Trigger decomposition pipeline
 */
export async function triggerDecomposition(marketId) {
  const response = await fetch(API_ENDPOINTS.decompose(marketId), {
    method: 'POST',
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to start decomposition');
  }

  return response.json();
}

/**
 * Propagate news through the graph
 */
export async function propagateNews(marketId, newsText) {
  const response = await fetch(API_ENDPOINTS.propagate(marketId), {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ news_text: newsText }),
  });

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to propagate news');
  }

  return response.json();
}

/**
 * Get graph data for visualization
 */
export async function getGraph(marketId) {
  const response = await fetch(API_ENDPOINTS.getGraph(marketId));

  if (!response.ok) {
    const error = await response.json();
    throw new Error(error.error || 'Failed to fetch graph');
  }

  return response.json();
}
